import React from 'react';
import { Link } from 'react-router-dom';

const BlogItem = ({ blogitem }) => {
    return (
        <>
            <div class="full-col col-lg-12 col-md-12">
                <div class="single-blog-inner" data-aos="fade-up"
                    data-aos-duration="800">
                    <div class="thumb">
                        <Link to={`/blog/${blogitem?.paramlink}`} className="no-underline">
                            <img src={blogitem.mediapath} alt={blogitem?.title}  />
                        </Link>
                        <ul class="blog-meta">
                            <li><i class="fa fa-user-o"></i> Author: {blogitem.authorname}</li>
                            <li><i class="fa fa-calendar"></i> Date: {blogitem.posteddate}</li>
                        </ul>
                    </div>
                    <div class="details">
                        <h4><Link to={`/blog/${blogitem?.paramlink}`} className="no-underline">{blogitem?.title}</Link></h4>
                        <p>{blogitem.shortdescription}</p>
                        <Link to={`/blog/${blogitem?.paramlink}`} class="read-more-btn"><i class="bx bx-chevron-right"></i></Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogItem;